import { createSelector } from '@reduxjs/toolkit';
import { EPublishPeriod } from '../../../../packages/api-models/common/json_query';
import { selectPublicationDate } from 'shared/selectors/jsonQuery';

const OPTIONS = [
  { label: 'Неважно', value: EPublishPeriod.Any },
  { label: 'За месяц', value: EPublishPeriod.Month },
  { label: 'За неделю', value: EPublishPeriod.Week },
  { label: 'За сегодня', value: EPublishPeriod.Today },
  { label: 'За час', value: EPublishPeriod.Hour },
];

export const selectPublicationDateFilter = createSelector(selectPublicationDate, value => ({
  value: value !== null ? value : EPublishPeriod.Any,
  options: OPTIONS,
}));
